/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizercreate1Inputs */

const en_organizercreate1 = /** @type {(inputs: Organizercreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create organizer`)
};

const de_organizercreate1 = /** @type {(inputs: Organizercreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstalter anlegen`)
};

/**
* | output |
* | --- |
* | "Create organizer" |
*
* @param {Organizercreate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizercreate1 = /** @type {((inputs?: Organizercreate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizercreate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizercreate1(inputs)
	return de_organizercreate1(inputs)
});
export { organizercreate1 as "organizerCreate" }